function quickView() {
  console.log("Global Quick Add Modal JS Loaded");

  if (!customElements.get('quick-add-modal')) {
    class QuickAddModal extends HTMLElement {
      connectedCallback() {
        this.modalContent = this.querySelector('#QuickAddInfo');
        this.closeBtn = this.querySelector('.quick-add-modal__close');
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.hide());
        }

        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });
      }

      show(productUrl, button) {
        if (button) {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');
        }

        fetch(productUrl)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const productElement = doc.querySelector('.section-product.quick-view');

            if (this.modalContent) {
              this.modalContent.innerHTML = productElement
                ? productElement.outerHTML
                : '<p>Product not found.</p>';
            }

            this.classList.add('show');
            quantity();
          })
          .catch((err) => {
            console.error('Quick View fetch error:', err);
            if (this.modalContent) {
              this.modalContent.innerHTML = '<p>Failed to load product details.</p>';
            }
          })
          .finally(() => {
            if (button) {
              button.removeAttribute('aria-disabled');
              button.classList.remove('loading');
            }
          });
      }

      hide() {
        if (this.modalContent) this.modalContent.innerHTML = '';
        this.classList.remove('show');
      }
    }

    customElements.define('quick-add-modal', QuickAddModal);
  }
  
  document.querySelectorAll('.quick-add__submit').forEach((btn) => {
    btn.addEventListener('click', () => {
      const productUrl = btn.dataset.productUrl;
      const modal = document.querySelector('#QuickAddModal');
      if (modal) modal.show(productUrl, btn);
    });
  });
}

quickView();